module.exports = "mutation UpdateIssueTagsOrder($tags:[UpdateIssueTagOrderInput]!){updateIssueTagsOrder(tags:$tags){success}}"